<template>
  <!-- 转正申请 -->
  <div class="promotionPage" v-if="!showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="申请人："
        :value="mode == 'add' ? baseData.realName : baseData.realName"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="所属部门："
        required
        v-model="baseData.departmentName"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="性别："
        :value="
          baseData.gender == 'm' ? '男' : baseData.gender == 'fm' ? '女' : ''
        "
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="员工状态："
        :value="changeStatus(baseData.status)"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="出生日期："
        v-model="baseData.birthday"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell title="民族：" v-model="baseData.nation" class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="居住地："
        v-model="baseData.residenceAddress"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell title="籍贯：" v-model="baseData.nativePlace" class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="政治面貌："
        v-model="baseData.politicsStatus"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="最高学历："
        :value="changeEducatuin(baseData.highestEducation)"
        class="ggInput"
      />
    </van-cell-group>

    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        readonly
        label="实际转正日期"
        :required="editType"
        v-model="baseData.positiveDate"
        @click="showTimePicker = true"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="baseData.reason"
        rows="1"
        autosize
        :required="editType"
        label="申请原因"
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <!-- 附件 -->
    <!-- 微信的附件 避免和原生交互 -->
    <wx-file-view
      v-if="is_weixn"
      :filesData="baseData"
      :editType="editType"
      class="fileview"
    ></wx-file-view>
    <!-- 原生附件 -->
    <file-view
      v-else
      :filesData="baseData"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view>

    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="mode !== 'add' && baseData.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="baseData"></audit-list>
    </div>

    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="mode !== 'add' && baseData.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="baseData"></flow-staff>
      <flow-list :workflowCode="baseData.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main :applicantData="baseData"   @changeVerifyType="setVerifyType"></verify-main>
    </van-popup>
    <!-- 保存按钮 -->

    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="baseData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply('del')"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="baseData.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        baseData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply('ch')"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          baseData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          baseData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 时间选择器 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { dateFormat } from "@/utils/common";
import { getDeviceType, closePage ,is_wei} from "@/common/getDeviceType/getDeviceType";
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const flowStaff = () => import("@/components/common/flowStaff");
const verifyMain = () => import("@/components/common/verifyMain");
export default {
  name: "promotionOffice",
  data() {
    return {
      baseData: {
        birthday: "",
        departmentName: "",
        gender: "",
        highestEducation: "",
        nation: "",
        nativePlace: "",
        politicsStatus: "",
        positiveDate: "",
        realName: "",
        reason: "",
        residenceAddress: "",
        baseAnnexes: [], //附件
        verifyStatus: "hold",
      },
      mode: "",
      editType: false,
      minDate: new Date(2000, 1, 1),
      currentDate: new Date(), //当前时间
      showTimePicker: false,
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      clientType: getDeviceType(), //手机类型
      sendType: "", //判断是否在抄送列表
       is_weixn: is_wei(), //是否为微信
    };
  },
  created() {
    document.title = "转正申请";
  },
  mounted() {
    window.editPage = this.editPage; //编辑页面
      let userAgent = window.navigator.userAgent.toLowerCase();
    this.userAgentType = userAgent.indexOf("dhoa") != -1 ? true : false;
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    this.setShowLoad(false); //加载状态，默认为true加载
    if (this.userinfo && this.userinfo.id) {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      this.initPage();
    }
  },
  components: {
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //app调用编辑
      this.editType = true;
    },
    verifyPage() {
      //app调用审批
      this.verifyPageType = true;
    },
    initPage() {
      if (this.mode == "add") {
        this.baseData = newApi.assign({}, this.baseData, this.userinfo);
        this.$set(this.baseData, "verifyStatus", "hold");
        this.baseData.positiveDate =
          this.baseData.positiveDate == null ? "" : this.baseData.positiveDate;
      } else {
        this.getDetails();
      }
    },
    getDetails() {
      let _this = this;
      _this.$api.userCenter.user.positionApply
        .positiveDetail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = newApi.assign({}, _this.baseData, res.data);
            _this.baseData.positiveDate =
              _this.baseData.positiveDate == null
                ? ""
                : _this.baseData.positiveDate;
            if (
              (_this.baseData.verifyStatus == "hold" ||
                _this.baseData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
          let text = "网络失败，请稍后重试";
        });
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.baseData.baseAnnexes = data;
    },
     //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    changeEducatuin(code) {
      let codeName = "";
      if (code == "xueli001") {
        codeName = "本科";
      } else if (code == "xueli002") {
        codeName = "专科";
      } else if (code == "xueli003") {
        codeName = "研究生";
      } else if (code == "xueli004") {
        codeName = "博士及以上";
      } else {
        codeName = "";
      }
      return codeName;
    },
    changeStatus(code) {
      let codeName = "";
      if (code == "sx") {
        codeName = "实习";
      } else if (code == "sy") {
        codeName = "试用";
      } else if (code == "zs") {
        codeName = "正式";
      } else if (code == "lg") {
        codeName = "离岗";
      } else if (code == "lz") {
        codeName = "离职";
      } else if (code == "tx") {
        codeName = "退休";
      } else {
        codeName = "";
      }
      return codeName;
    },
    onTimeConfirm(data) {
      //选择时间回调
      this.showTimePicker = false;
      this.baseData.positiveDate = dateFormat(data);
    },
    checkInput() {
      let _this = this;
      console.log(_this.baseData);
      if (_this.baseData.reason == "" || _this.baseData.positiveDate == "") {
        _this.$toast("带星号为必填，不能为空");
      } else {
        _this.saveLeave();
      }
    },
    saveLeave() {
      //提交离职申请
      let _this = this;
      _this.btnLoading = true;
      _this.$api.userCenter.user.positionApply
        .addPositive(_this.mode, _this.baseData)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    delApply(type) {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.userCenter.user.positionApply
        .delApply(type, _this.baseData.id)
        .then((res) => {
          if (res.code == "1") {
            let text = type == "ch" ? "撤回操作成功" : "删除操作成功";
            closePage(text);
          } else {
            // console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
          this.initPage();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.promotionPage {
  width: 100%;
  background-color: #f6f6f6;
  padding-top: 12px;
  padding-bottom: 70px;
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
}
</style>